<template>
  <div class="contribute-link">
    <div class="link">
      <a href="https://gitlab.com/lkwg82/gitlab-pipeline-dashboard-v3" target="gitlab">
        Made with ❤️ - contribute!
      </a>
    </div>
    <div class="git">
      {{ git_hash }} |
      {{ git_date }}
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'ContributeLink',
  data() {
    return {
      git_hash: process.env.VUE_APP_GIT_HASH,
      git_date: process.env.VUE_APP_GIT_DATE
    }
  }
})
</script>

<style scoped lang="scss">
.contribute-link {
  position: fixed;
  bottom: 0;
  text-shadow: 1px 1px 1px #fff, 1px 1px 1px #ccc;

  .link {
    text-align: center;
  }

  .git {
    font-size: xx-small;
    text-shadow: none;
  }

  .heart {
    color: red;
  }
}
</style>
